export enum PageType {
  SignIn = 1, // 登录注册
  ForgotPassword = 2, // 忘记密码
  PhoneSignIn = 3, // 手机号登录注册
  PhoneVerification = 4, // 输入手机号验证码
  SignInOnly = 5 // 仅登录
}

export const messages = {
  zh: {
    pageTip: '请提供详细的问题描述和截图，我们会尽快回复您！如果您离开，我们将通过电子邮件回复您。',
    or: '或者',
    login: '登录',
    continue: '继续'
  },
  en: {
    pageTip: 'Would you please provide your detailed questions with text description and screenshots if possible. We will assit ASAP! lf you leave, you will be emailed a reponse.',
    or: 'Or',
    login: 'log in',
    continue: 'to continue'
  },
  tr: {
    pageTip: 'Lütfen mümkünse metin açıklaması ve ekran görüntüleri ile detaylı sorunuzu paylaşın. En kısa sürede yardımcı olacağız! Sayfadan ayrılırsanız, size e‑posta ile yanıt gönderilecektir.',
    or: 'Veya',
    login: 'Giriş yap',
    continue: 'Devam et',
  },
  sl: {
    pageTip: 'Prosimo, navedite podrobno opis vprašanja s tekstovnim opisom in posnetki zaslona, če je mogoče. Pomagali vam bomo ASAP! Če zapustite stran, vam bomo odgovorili po e‑pošti.',
    or: 'Ali',
    login: 'Prijava',
    continue: 'Nadaljuj',
  },
  sk: {
    pageTip: 'Prosím, poskytnite podrobný popis problému s textovým popisom a snímkami obrazovky, ak je to možné. Pomôžeme čo najskôr! Ak opustíte stránku, odpoveď vám bude zaslaná e‑mailom.',
    or: 'Alebo',
    login: 'Prihlásiť sa',
    continue: 'Pokračovať',
  },
  lt: {
    pageTip: 'Prašome pateikti išsamią problemos aprašymą su teksto aprašymu ir ekrano kopijomis, jei įmanoma. Mes padėsime kuo greičiau! Jei išeisite, jums bus išsiųstas atsakymas el. paštu.',
    or: 'Arba',
    login: 'Prisijungti',
    continue: 'Tęsti',
  },
  et: {
    pageTip: 'Palun esitage üksikasjalik probleemikirjeldus koos tekstilise selgituse ja ekraanipiltidega, kui võimalik. Aitame nii kiiresti kui võimalik! Kui lahkute, saadetakse teile vastus e‑posti teel.',
    or: 'Või',
    login: 'Logi sisse',
    continue: 'Jätka',
  },
  lv: {
    pageTip: 'Lūdzu, sniedziet detalizētu problēmas aprakstu ar teksta paskaidrojumu un ekrānšāviņiem, ja iespējams. Mēs palīdzēsim pēc iespējas ātrāk! Ja jūs atstājat lapu, jums tiks nosūtīta atbilde pa e‑pastu.',
    or: 'Vai',
    login: 'Pieslēgties',
    continue: 'Turpināt',
  },
  el: {
    pageTip: 'Παρακαλώ παρέχετε μια λεπτομερή περιγραφή του προβλήματος με κείμενο και στιγμιότυπα οθόνης, εάν είναι δυνατόν. Θα σας βοηθήσουμε το συντομότερο δυνατό! Αν φύγετε, θα σας αποσταλεί απάντηση μέσω email.',
    or: 'Ή',
    login: 'Σύνδεση',
    continue: 'Συνέχεια',
  },
  it: {
    pageTip: 'Si prega di fornire una descrizione dettagliata del problema con testo e screenshot se possibile. Ti assisteremo al più presto! Se lasci la pagina, riceverai una risposta via e‑mail.',
    or: 'O',
    login: 'Accedi',
    continue: 'Continua',
  },
  es: {
    pageTip: 'Por favor, proporcione una descripción detallada del problema con texto y capturas de pantalla si es posible. Le asistiremos lo antes posible. Si abandona la página, recibirá una respuesta por correo electrónico.',
    or: 'O',
    login: 'Iniciar sesión',
    continue: 'Continuar',
  },
  pt: {
    pageTip: 'Por favor, forneça uma descrição detalhada do problema com texto e capturas de tela, se possível. Ajudaremos o mais rápido possível! Se você sair da página, receberá uma resposta por e‑mail.',
    or: 'Ou',
    login: 'Entrar',
    continue: 'Continuar',
  },
  mt: {
    pageTip: 'Jekk jogħġbok provdi deskrizzjoni dettaljata tal-problema tiegħek b’test u screenshots jekk possibbli. Għandna appoġġ kemm jista’ malajr! Jekk titilfu mill-paġna, se tirċievi rispons bl-email.',
    or: 'Jew',
    login: 'Idħol',
    continue: 'Ibqa’',
  },
  fr: {
    pageTip: 'Veuillez fournir une description détaillée de votre problème avec du texte et des captures d’écran si possible. Nous vous assisterons dès que possible ! Si vous quittez la page, vous recevrez une réponse par e‑mail.',
    or: 'Ou',
    login: 'Se connecter',
    continue: 'Continuer',
  },
  de: {
    pageTip: 'Bitte geben Sie eine detaillierte Problembeschreibung mit Text und Screenshots an, falls möglich. Wir helfen Ihnen so schnell wie möglich! Wenn Sie die Seite verlassen, erhalten Sie eine Antwort per E‑Mail.',
    or: 'Oder',
    login: 'Anmelden',
    continue: 'Weiter',
  },
  nl: {
    pageTip: 'Geef alstublieft een gedetailleerde beschrijving van uw probleem met tekst en screenshots indien mogelijk. We helpen u zo snel mogelijk! Als u de pagina verlaat, ontvangt u een antwoord per e‑mail.',
    or: 'Of',
    login: 'Inloggen',
    continue: 'Doorgaan',
  },
  fi: {
    pageTip: 'Kirjoita yksityiskohtainen kuvaus ongelmasta tekstinä ja kuvakaappauksina, jos mahdollista. Autamme mahdollisimman pian! Jos poistut sivulta, saat vastauksen sähköpostitse.',
    or: 'Tai',
    login: 'Kirjaudu sisään',
    continue: 'Jatka',
  },
  sv: {
    pageTip: 'Vänligen ge en detaljerad beskrivning av ditt problem med text och skärmdumpar om möjligt. Vi hjälper dig så snart som möjligt! Om du lämnar sidan får du ett svar via e‑post.',
    or: 'Eller',
    login: 'Logga in',
    continue: 'Fortsätt',
  },
  da: {
    pageTip: 'Angiv venligst en detaljeret beskrivelse af dit problem med tekst og skærmbilleder hvis muligt. Vi hjælper dig hurtigst muligt! Hvis du forlader siden, får du et svar via e‑mail.',
    or: 'Eller',
    login: 'Log ind',
    continue: 'Fortsæt',
  },
  no: {
    pageTip: 'Vennligst oppgi en detaljert beskrivelse av problemet ditt med tekst og skjermbilder hvis mulig. Vi vil hjelpe deg så snart som mulig! Hvis du forlater siden, vil du motta et svar på e‑post.',
    or: 'Eller',
    login: 'Logg inn',
    continue: 'Fortsett',
  },
  is: {
    pageTip: 'Vinsamlegast gefðu ítarlegan lýsingu á vandamálinu þínu með textalýsingu og skjáskotum ef mögulegt er. Við munum aðstoða eins fljótt og auðið er! Ef þú yfirgefur síðuna muntu fá svar í tölvupósti.',
    or: 'Eða',
    login: 'Skrá inn',
    continue: 'Haltu áfram',
  },
  pl: {
    pageTip: 'Prosimy podać szczegółowy opis problemu z treścią i zrzutami ekranu, jeśli to możliwe. Pomożemy tak szybko, jak to możliwe! Jeśli opuścisz stronę, otrzymasz odpowiedź e‑mailem.',
    or: 'Lub',
    login: 'Zaloguj się',
    continue: 'Kontynuuj',
  },
  ru: {
    pageTip: 'Пожалуйста, предоставьте подробное описание вашей проблемы с текстовым описанием и скриншотами, если возможно. Мы поможем как можно скорее! Если вы покинете страницу, вы получите ответ по электронной почте.',
    or: 'Или',
    login: 'Войти',
    continue: 'Продолжить',
  },
  ca: {
    pageTip: 'Proporcione una descripció detallada del vostre problema amb text i captures de pantalla si és possible. Us ajudarem tan aviat com sigui possible! Si abandoneu la pàgina, rebreu una resposta per correu electrònic.',
    or: 'O',
    login: 'Iniciar sessió',
    continue: 'Continuar',
  },
  ro: {
    pageTip: 'Vă rugăm să furnizați o descriere detaliată a problemei dvs. cu text și capturi de ecran, dacă este posibil. Vă vom asista cât mai curând posibil! Dacă părăsiți pagina, veți primi un răspuns prin e‑mail.',
    or: 'Sau',
    login: 'Autentificare',
    continue: 'Continuă',
  },
  bg: {
    pageTip: 'Моля, предоставете подробно описание на проблема си с текст и екранни снимки, ако е възможно. Ще ви помогнем възможно най-скоро! Ако напуснете страницата, ще получите отговор по имейл.',
    or: 'Или',
    login: 'Вход',
    continue: 'Продължи',
  },
  hu: {
    pageTip: 'Kérjük, adjon részletes problémaleírást szöveggel és képernyőképekkel, ha lehetséges. Segítünk amint lehetséges! Ha elhagyja az oldalt, e‑mailben kap választ.',
    or: 'Vagy',
    login: 'Bejelentkezés',
    continue: 'Folytatás',
  },
  lb: {
    pageTip: `Gitt e detailléierten Beschreiwung vun Ärem Problem mat Text an Screenshot ech wann méiglech. Mir hëllefen esou séier wéi méiglech! Wann Dir d'Säit verlaascht, kritt Dir eng Äntwert per E‑Mail.`,
    or: 'Oder',
    login: 'Aloggen',
    continue: 'Weider',
  },
  cs: {
    pageTip: 'Prosím, poskytněte podrobný popis vašeho problému s textovým popisem a snímky obrazovky, pokud je to možné. Pomůžeme co nejdříve! Pokud stránku opustíte, dostanete odpověď e‑mailem.',
    or: 'Nebo',
    login: 'Přihlásit se',
    continue: 'Pokračovat',
  },
  nb: {
    pageTip: 'Vennligst gi en detaljert beskrivelse av problemet ditt med tekst og skjermbilder hvis mulig. Vi vil hjelpe deg så snart som mulig! Hvis du forlater siden, vil du motta et svar på e‑post.',
    or: 'Eller',
    login: 'Logg inn',
    continue: 'Fortsett',
  },
  hr: {
    pageTip: 'Molimo pružite detaljan opis vašeg problema s tekstom i snimkama zaslona ako je moguće. Pomoći ćemo što je prije moguće! Ako napustite stranicu, dobit ćete odgovor putem e-pošte.',
    or: 'Ili',
    login: 'Prijava',
    continue: 'Nastavi',
  },
}
